import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import  {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import  {environment} from '../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {ThongBao} from '../../../models/info/thongbao';
import {language} from '../../../language/vn';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {CommandUtil} from '../../../global/commandutil';
import {Sessioncommand} from '../../../global/sessioncommand';
import {FormatService} from '../../../service/format/service-format';
import {XuLyDetailThongBaoComponent} from './xulydetail.component';
import {YKTongHopThongBaoComponent} from './tonghop.component';
import {RolePermissionService} from '../../../service/security/service-rolepermission';
import {DatePipe} from '@angular/common';
import {ThongBaoStaff} from '../../../models/info/thongbaostaff';
import {ThongBaoStaffService} from '../../../service/info/service-thongbaostaff';
import {LogViewItemEgovComponent} from '../log/logviewitem.component';
@Component({
  templateUrl: './thongbaoview.component.html',

})
export class ThongBaoViewComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  @ViewChild(XuLyDetailThongBaoComponent)
  public xuLyThongBaoDetail: XuLyDetailThongBaoComponent;
  private moduleName:  string = 'egov.info.thongbao.doc';
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public dataList: ThongBao[]=[];
  public srChuDe: string = '';
  public nguoiNhapId: number = -1;
  public flag: boolean = false;
  public dateCurrent: Date = new Date();
  public staffId: number = Sessioncommand.staffId;
  public nextId: number = 0;
  public thongBaoId: number = 0;
  public showDetails: boolean = false;
  public permissionView: boolean = false;
  public permissionUpdate: boolean = false;
  public permissionDelete: boolean = false;
  public permissionToanQuyen: boolean = false;
  public permissionYKienTongHop: boolean = false;
  public permissionDownloadFile: boolean = false;
  public permissionDocThongBao: boolean = false;
  public permissionYKien: boolean = false;
  public srFromDate: Date ;
  public srToDate: Date;
  public strF: string= '';
  public strT: string= '';
  public thongBaoStaffList: ThongBaoStaff[] = [];
  private searchTuongDoi: number = environment.SEARCH_TUONGDOI;
  private searchChinhXac: number = environment.SEARCH_CHINHXAC;
  private srSearchType: number = environment.SEARCH_TUONGDOI;
  constructor(
    public thongBaoService: ThongBaoService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public commandUtil: CommandUtil,
    public formatService: FormatService,
    public datePipe: DatePipe,
    public rolePermissionService: RolePermissionService,
    public thongBaoStaffService: ThongBaoStaffService

  ) {
  }
  ngAfterViewInit() {
  }
  ngOnInit(): void {
    this.formatService.getCurrentDateVN().subscribe( x => this.dateCurrent = this.commandUtil.getDate(x));
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionView = x.findIndex(y => y.action === environment.view) !== -1;
      this.permissionToanQuyen = x.findIndex(y => y.action === environment.toanquyen) !== -1;
      this.nguoiNhapId = x.findIndex(y => y.action === environment.xemtatca) !== -1 || this.permissionToanQuyen ? -1 : this.nguoiNhapId;
      if (this.permissionView)
        this.search();
      else
        this.rolePermissionService.redirectAccesDenied();
      this.permissionYKien = x.findIndex(y => y.action === environment.ykien) !== -1;
      this.permissionDelete = x.findIndex(y => y.action === environment.delete) !== -1;
      this.permissionYKienTongHop = x.findIndex(y => y.action === environment.ykientonghop) !== -1;
      this.permissionDownloadFile = x.findIndex(y => y.action === environment.download) !== -1;
      this.permissionDocThongBao = x.findIndex(y => y.action === environment.docthongbao) !== -1;
    });


  }
  public lichSuTruyCap(id: number) {
    const modalEdit = this.bsModalService.show(LogViewItemEgovComponent, {class: 'modal-lg', keyboard: false, backdrop: 'static'});
    (<LogViewItemEgovComponent>modalEdit.content).show(
      id, environment.THONGBAO
    );
    (<LogViewItemEgovComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  get f() { return this.frmGroup.controls; }
  public ykienTH(id: number) {

    const modalEdit = this.bsModalService.show(YKTongHopThongBaoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKTongHopThongBaoComponent>modalEdit.content).edit(
      id
    );
    (<YKTongHopThongBaoComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  search()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.thongBaoService.findAllByTargetDatePaging(this.srChuDe, this.srSearchType, this.permissionToanQuyen === true ? -1 : this.staffId, this.nguoiNhapId, this.strF, this.strT, this.currentPage, this.maxSize)
      .subscribe(dataList => {
        this.dataList = dataList;
        this.flag = true;
        this.loadReadThongBao(this.dataList);
      });
    this.thongBaoService.getCountByTargetDateKeyword(this.srChuDe, this.srSearchType, this.permissionToanQuyen === true?-1: this.staffId,  this.nguoiNhapId, this.strF, this.strT).subscribe(recordCount => this.totalItems = recordCount);
  }
  loadReadThongBao(dataThongBao: ThongBao[])
  {
    if(dataThongBao !== null && dataThongBao.length > 0) {
      const arrIds = dataThongBao.map(x => x.id).join(',');
      this.thongBaoStaffService.findAllByThongBaoIdArray(arrIds, this.staffId)
        .subscribe(dataList => {
          this.thongBaoStaffList = dataList;
        });
    }
  }
  checkRead(id: number): boolean
  {
    if (this.thongBaoStaffList === null || this.thongBaoStaffList.length === 0)
      return false;
    return this.thongBaoStaffList.findIndex(x => x.thongBaoID === id)!== -1 ? true: false;
  }

  deleteItem(id: number)
  {
    this.thongBaoService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();
        Sessioncommand.giaiQuyetSuVuStatus = 0;


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }
  public detailXuLy(id: number) {
    if(this.permissionToanQuyen || this.permissionYKien) {
      this.thongBaoId = id;
      this.nextId = this.dataList.findIndex(x => x.id === id);
      this.showDetails = true;
    }
  }

  public nextPage()
  {
    if( this.nextId + 1 >= this.dataList.length)
    {
      if(this.currentPage < this.numPages) {
        this.currentPage = this.currentPage + 1;
        this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
        this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
        this.thongBaoService.findAllByTargetDatePaging(this.srChuDe, this.srSearchType, this.staffId, this.nguoiNhapId, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          this.loadReadThongBao(this.dataList);
          if (this.dataList.length > 0)
          {
            this.thongBaoId = this.dataList[0].id;
            this.nextId = 0;
            this.xuLyThongBaoDetail.edit(this.thongBaoId);
          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId + 1;
      this.thongBaoId = this.dataList [ this.nextId === this.dataList.length ? this.dataList.length -1 : this.nextId ].id;
      this.xuLyThongBaoDetail.edit( this.thongBaoId);
      this.loadReadThongBao(this.dataList);
    }
  }
  public backPage()
  {
    if( this.nextId - 1  < 0)
    {
      if(this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
        this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
        this.thongBaoService.findAllByTargetDatePaging(this.srChuDe, this.srSearchType, this.staffId, this.nguoiNhapId, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          this.loadReadThongBao(this.dataList);
          if (this.dataList.length > 0)
          {
            this.nextId = this.dataList.length - 1;
            this.thongBaoId = this.dataList[this.nextId].id;
            this.xuLyThongBaoDetail.edit(this.thongBaoId);

          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId  - 1;
      this.thongBaoId = this.dataList [ this.nextId === -1 ? 0 : this.nextId].id;
      this.xuLyThongBaoDetail.edit( this.thongBaoId);
      this.loadReadThongBao(this.dataList);
    }
  }
}

